import type { ColDef, ColGroupDef, GridOptions } from '@ag-grid-community/core';
import type { FilterBarField, SelectedFilterField } from '@cdw-ae/filter-bar-interfaces';
import { Observable, throwError } from 'rxjs';
import { DevicesDataService } from '../../../../../common/services/device/devices-data.service';
import { USER_REPORT_COLUMN_DEFS, USER_REPORT_GRID_OPTIONS } from '../configs/user-report.config';
import { ReportData } from '../report-viewer/report-viewer.model';
import { BaseReportHandler } from './base-report.handler';

/**
 * Handler for User reports
 * Manages grid configuration for user device session reports
 */
export class UserReportHandler extends BaseReportHandler {
  /**
   * User reports come pre-populated from navigation state
   * This method should never be called - throw error if it is
   */
  static load(
    _devicesDataService: DevicesDataService,
    _filters?: SelectedFilterField[]
  ): Observable<ReportData> {
    return throwError(
      () =>
        new Error(
          'User reports are pre-populated and should not call load(). Navigate with reportData in state instead.'
        )
    );
  }

  getColumnDefs(): (ColDef | ColGroupDef)[] {
    return USER_REPORT_COLUMN_DEFS;
  }

  getGridOptions(): GridOptions {
    return USER_REPORT_GRID_OPTIONS;
  }

  static override getFilterBarSettings(): FilterBarField[] | null {
    // User reports don't have filter bar support yet
    return null;
  }

  static override getInitialFilters(): SelectedFilterField[] | null {
    // User reports don't have initial filters
    return null;
  }

  /**
   * User reports don't process raw data - they receive pre-formatted data
   * Just return the data as-is
   */
  static override processRawData(rawData: unknown[], _filters: SelectedFilterField[]): unknown[] {
    return rawData;
  }
}
